module.exports = __webpack_public_path__ + "fonts/hk-grotesk.medium.903a340c.ttf";